import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { WSClient } from '@/lib/ws-client'
import { getWSConfig } from '@/api/brain'
import { useSessions } from '@/hooks/useBrainAPI'
import { ChatWindow, SessionList } from '@/components/chat'

export function Chat() {
  const navigate = useNavigate()
  const [wsClient, setWsClient] = useState<WSClient | null>(null)
  const [connected, setConnected] = useState(false)
  const [sessionId, setSessionId] = useState<string | null>(null)
  const [showSidebar, setShowSidebar] = useState(window.innerWidth > 768)
  const { data: sessions = [], isLoading: sessionsLoading } = useSessions()

  // Connect WS on mount
  useEffect(() => {
    let client: WSClient | null = null

    getWSConfig()
      .then(({ wsUrl, token }) => {
        client = new WSClient(wsUrl, token)
        client.on('open', () => setConnected(true))
        client.on('close', () => setConnected(false))
        client.connect()
        setWsClient(client)
      })
      .catch((err) => console.error('[chat] WS config failed:', err))

    return () => {
      client?.disconnect()
    }
  }, [])

  return (
    <div className="flex flex-col h-screen bg-swiss-white">
      {/* Top bar */}
      <div className="flex items-center justify-between px-4 h-12 border-b border-swiss-gray-200 bg-swiss-white flex-shrink-0">
        <div className="flex items-center gap-3">
          <button
            onClick={() => navigate('/')}
            className="font-swiss-sans text-swiss-body text-swiss-gray-500 hover:text-swiss-black"
          >
            &larr; Back
          </button>
          <span className="font-swiss-mono text-swiss-label uppercase tracking-[0.1em] text-swiss-gray-500">
            Chat
          </span>
        </div>
        <button
          onClick={() => setShowSidebar(!showSidebar)}
          className="font-swiss-mono text-swiss-caption text-swiss-gray-500 hover:text-swiss-black"
        >
          {showSidebar ? 'Hide Sessions' : 'Show Sessions'}
        </button>
      </div>

      {/* Main area */}
      <div className="flex flex-1 min-h-0">
        {showSidebar && (
          <SessionList
            sessions={sessions}
            activeSessionId={sessionId}
            onSelect={(id) => setSessionId(id)}
            onNew={() => setSessionId(null)}
            isLoading={sessionsLoading}
          />
        )}
        <ChatWindow
          wsClient={wsClient}
          connected={connected}
          sessionId={sessionId}
          onSessionCreated={(id) => setSessionId(id)}
        />
      </div>
    </div>
  )
}
